function pad(n) {
  return String(n).padStart(2, '0')
}

export function formatDate(date) {
  const y = date.getFullYear()
  const m = pad(date.getMonth() + 1)
  const d = pad(date.getDate())
  return `${y}-${m}-${d}`
}

/** ISO 8601 周：周一为一周开始 */
export function getWeekRange(dateInput) {
  const date = dateInput instanceof Date ? new Date(dateInput) : new Date(String(dateInput).replace(/-/g, '/'))
  if (Number.isNaN(date.getTime())) {
    const today = new Date()
    return getWeekRange(today)
  }
  const day = date.getDay()
  const diffToMonday = day === 0 ? -6 : 1 - day
  const monday = new Date(date)
  monday.setHours(0, 0, 0, 0)
  monday.setDate(date.getDate() + diffToMonday)
  const sunday = new Date(monday)
  sunday.setDate(monday.getDate() + 6)
  return { start: formatDate(monday), end: formatDate(sunday), monday, sunday }
}

export function getLastWeekRange(dateInput) {
  const current = getWeekRange(dateInput)
  const lastMonday = new Date(current.monday)
  lastMonday.setDate(lastMonday.getDate() - 7)
  const lastSunday = new Date(lastMonday)
  lastSunday.setDate(lastMonday.getDate() + 6)
  return { start: formatDate(lastMonday), end: formatDate(lastSunday) }
}

export function dateToWeekInput(date) {
  const d = date instanceof Date ? date : new Date(String(date).replace(/-/g, '/'))
  const temp = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  const dayNum = temp.getUTCDay() || 7
  temp.setUTCDate(temp.getUTCDate() + 4 - dayNum)
  const yearStart = new Date(Date.UTC(temp.getUTCFullYear(), 0, 1))
  const weekNo = Math.ceil((((temp - yearStart) / 86400000) + 1) / 7)
  return `${temp.getUTCFullYear()}-W${pad(weekNo)}`
}

export function weekInputToDate(weekValue) {
  if (!weekValue) return new Date()
  const match = String(weekValue).match(/^(\d{4})-W(\d{2})$/)
  if (!match) return new Date()
  const year = parseInt(match[1], 10)
  const week = parseInt(match[2], 10)
  const simple = new Date(year, 0, 1 + (week - 1) * 7)
  const dayOfWeek = simple.getDay()
  const isoWeekStart = simple
  if (dayOfWeek <= 4) {
    isoWeekStart.setDate(simple.getDate() - simple.getDay() + 1)
  } else {
    isoWeekStart.setDate(simple.getDate() + 8 - simple.getDay())
  }
  return isoWeekStart
}

export function isDateInRange(dateStr, start, end) {
  if (!dateStr) return false
  const normalized = String(dateStr).trim()
  let datePart = normalized.slice(0, 10)
  if (/^\d{10}$/.test(normalized)) {
    datePart = formatDate(new Date(Number(normalized) * 1000))
  } else if (/^\d{13}$/.test(normalized)) {
    datePart = formatDate(new Date(Number(normalized)))
  } else {
    datePart = datePart.replace(/\//g, '-')
  }
  return datePart >= start && datePart <= end
}
